import React from 'react';
import classNames from 'classnames';
import styles from './TabButton.module.css';
import cn from 'classnames'

interface TabButtonProps {
  children: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
  theme: string;
}

const TabButton: React.FC<TabButtonProps> = ({ children, isActive, onClick, theme }) => {

  const wrapperClass = cn(styles.wrapper, {
    [styles.light]: theme === 'light',
    [styles.dark]: theme === 'dark',
  });

  return (
    <button
      className={classNames('text_subheaders_sh3', wrapperClass, {
        [styles.active]: isActive,
      })}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default TabButton;
